import { render, staticRenderFns } from "./CrearProgramacionInformeModal.vue?vue&type=template&id=852e4244&scoped=true&"
import script from "./CrearProgramacionInformeModal.vue?vue&type=script&lang=ts&"
export * from "./CrearProgramacionInformeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "852e4244",
  null
  
)

export default component.exports